import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { MailCheck } from 'lucide-react';
import * as authApi from '@/api/auth.api';
import { Button } from '@/components/ui/Button';
import { Input } from '@/components/ui/Input';
import { AuthShell } from './AuthShell';

/**
 * Página PÚBLICA "olvidé mi contraseña": pide el correo y muestra SIEMPRE el
 * mismo mensaje (el backend no filtra si la cuenta existe). Si el envío de
 * correo no está configurado en el servidor, el admin puede restablecer la
 * clave desde Usuarios — la página lo menciona.
 */
export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const request = useMutation({ mutationFn: () => authApi.forgotPassword(email.trim()) });

  return (
    <AuthShell title="Restablecer contraseña" subtitle="Le enviaremos un enlace a su correo.">
      {request.isSuccess ? (
        <div className="space-y-4 text-center">
          <MailCheck className="mx-auto h-10 w-10 text-emerald-500" />
          <p className="text-sm text-slate-600 dark:text-slate-300">
            Si el correo tiene una cuenta, recibirá un enlace para restablecer su clave
            (revise también el spam). El enlace vale por 1 hora.
          </p>
          <p className="text-xs text-slate-400">
            ¿No le llega? Pídale al administrador que le restablezca la clave desde el panel.
          </p>
          <Link to="/login">
            <Button variant="outline" className="w-full">Volver al inicio de sesión</Button>
          </Link>
        </div>
      ) : (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (email.trim()) request.mutate();
          }}
          className="space-y-4"
          noValidate
        >
          <Input
            label="Su correo"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="usted@empresa.com"
          />
          <Button type="submit" className="w-full" loading={request.isPending}>
            Enviarme el enlace
          </Button>
          <p className="text-center text-xs text-slate-400">
            <Link to="/login" className="text-acento-texto hover:underline">
              Volver al inicio de sesión
            </Link>
          </p>
        </form>
      )}
    </AuthShell>
  );
}
